import { render, staticRenderFns } from "./question_wrap.vue?vue&type=template&id=552d4c40"
import script from "./question_wrap.vue?vue&type=script&lang=js"
export * from "./question_wrap.vue?vue&type=script&lang=js"
import style0 from "./question_wrap.vue?vue&type=style&index=0&id=552d4c40&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports